<template>
    <div class="dailiInfo-wrap">
        <el-row :gutter="24">
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">渠道码</div>
                        <div class="text_color">
                            <span>{{ dailiInfo.shop_user_id }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">管理员昵称</div>
                        <div class="text_color">
                            <span>{{ dailiInfo.user_name }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">{{ dailiInfo.data && dailiInfo.data.bounty_type == 1 ? '渠道百分比' : '固定赏金' }}</div>
                        <div class="text_color">
                            <span>{{ dailiInfo.data && dailiInfo.data.bounty_ratio }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">钱包余额</div>
                        <div class="text_color">
                            <span>0</span>
                        </div>
                        <div>
                            <el-button style="margin: 3px;" type="warning" size="mini">提现</el-button>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">支付宝账号</div>
                        <div class="text_color">
                            {{ dailiInfo.data && dailiInfo.data.zfbaccount || '未知'}} 
                        </div>
                    </div>
                </div>
               
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">支付宝名称</div>
                        <div class="text_color">
                            {{ dailiInfo.data && dailiInfo.data.zfbname || '未知'}} 
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import ChannelApi from '@/api/channel.js';
export default {
    props:{
        dailiInfo:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
            // dailiInfo:{}
        }
    },
    created(){
        // this.getUserList()
    },
    methods:{
        getUserList(){
            ChannelApi.channel({}, true).then(res=>{
                console.log('channel', res);
                const {data} = res.data.list
                this.dailiInfo = data[0]
            })
        },
    }

}
</script>

<style lang="scss" scoped>
.box{
    height: 156px;
    padding: 24px;
    border: 1px solid #eee;
    margin: 15px 10px;
    
    .box_num{
        font-size: 14px;
        color: #66b1ff;
        .title_color{
            color: #333;
            font-size: 14px;
            // margin-bottom: 15px;
        }
        .text_color{
            color: #4f9dec;
            margin-top: 40px;
            span{
                font-size: 20px;
                margin-left: 5px;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/channel/user/daili/dailiInfo.vue